import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AuthService, VerifyResponse } from './core/auth/auth.service';

export const initialDataResolver = (): Observable<VerifyResponse> => {
  const authService = inject(AuthService);

  return authService.verify().pipe(
    tap((response) => {
      const aivaPermissions = response.permissionsByProduct.AIVA || [];
      localStorage.setItem('user-permissions', JSON.stringify(aivaPermissions));
    })
  );
};
